const japanPrefectures = {
  OVERSEA: 'Overseas',
  HOKKAIDO: 'Hokkaido',
  AOMORI: 'Aomori',
  IWATE: 'Iwate',
  MIYAGI: 'Miyagi',
  AKITA: 'Akita',
  YAMAGATA: 'Yamagata',
  FUKUSHIMA: 'Fukushima',
  IBARAKI: 'Ibaraki',
  TOCHIGI: 'Tochigi',
  GUNMA: 'Gunma',
  SAITAMA: 'Saitama',
  CHIBA: 'Chiba',
  TOKYO: 'Tokyo',
  KANAGAWA: 'Kanagawa',
  NIIGATA: 'Niigata',
  TOYAMA: 'Toyama',
  ISHIKAWA: 'Ishikawa',
  FUKUI: 'Fukui',
  YAMANASHI: 'Yamanashi',
  NAGANO: 'Nagano',
  GIFU: 'Gifu',
  SHIZUOKA: 'Shizuoka',
  AICHI: 'Aichi',
  MIE: 'Mie',
  SHIGA: 'Shiga',
  KYOTO: 'Kyoto',
  OSAKA: 'Osaka',
  HYOGO: 'Hyogo',
  NARA: 'Nara',
  WAKAYAMA: 'Wakayama',
  TOTTORI: 'Tottori',
  SHIMANE: 'Shimane',
  OKAYAMA: 'Okayama',
  HIROSHIMA: 'Hiroshima',
  YAMAGUCHI: 'Yamaguchi',
  TOKUSHIMA: 'Tokushima',
  KAGAWA: 'Kagawa',
  EHIME: 'Ehime',
  KOCHI: 'Kochi',
  FUKUOKA: 'Fukuoka',
  SAGA: 'Saga',
  NAGASAKI: 'Nagasaki',
  KUMAMOTO: 'Kumamoto',
  OITA: 'Oita',
  MIYAZAKI: 'Miyazaki',
  KAGOSHIMA: 'Kagoshima',
  OKINAWA: 'Okinawa'
};

export default japanPrefectures;
